import firebase from "./firebase"; // Import the initialized Firebase app

class FirebaseMessaging {
  messaging = firebase.messaging();

  async getToken() {
    try {
      // Same VAPID key as fnt/src/services/firebase.js
      const token = await this.messaging.getToken({
        vapidKey:
          "BFwWowecyp38AcnPsuY29GgPx9RZytrWEFS_mP5wqbtdQGOJkBLSAQp9xbBLDy7fkakqcNTOQZ2XW2BIcPZ3ERk",
      });
      return token;
    } catch (error) {
      console.error("Error fetching Firebase token:", error);
    }
  }

  async requestNotificationPermission() {
    try {
      if (typeof Notification === 'undefined') return null;

      // If already decided by the browser, don't request again.
      const current = Notification.permission; // 'default' | 'granted' | 'denied'
      if (current === 'denied') return null;

      if (current === 'default') {
        const result = await Notification.requestPermission();
        if (result !== 'granted') return null;
      }

      const token = await this.getToken();
      if (token) window.sessionStorage.setItem('fcm', token);
      return token;
    } catch (error) {
      // Avoid noisy error logs for permission-blocked scenarios.
      console.error('Error requesting permission:', error);
      return null;
    }
  }

  onMessage(callback) {
    this.messaging.onMessage(callback);
  }
}

export default new FirebaseMessaging();